/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
import { displayScreen } from 'redux/actions/screen_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Screen from 'components/screens/screen';



/* ========== ~~~~~~~~~~ SCREEN : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ screenStatus }) => screenStatus;


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
	mapStateToProps,
    null
)(Screen);
